module.exports = __webpack_public_path__ + "img/img-eat-02.95af5201.png";